import { render } from "./DrawingComponent.vue?vue&type=template&id=339af5c0"
import script from "./DrawingComponent.vue?vue&type=script&lang=js"
export * from "./DrawingComponent.vue?vue&type=script&lang=js"

import "./DrawingComponent.vue?vue&type=style&index=0&id=339af5c0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__